<ng-container *transloco="let convert;">
  <div class="advanced_search d-md-flex align-items-center">
    <trap-focus [enableFocusTrap]="makePop.isOpen" [focusOnFirstElem]="true" [enableArrowKeys]="true">
      <button
        class="btn btn-outline-primary advanced_search--btn"
        type="button"
        [popover]="makeTemplate"
        #makePop="bs-popover"
        placement="bottom"
        (onShown)="showMakeDropDown()"
        (keydown.escape)="makePop.hide()"
        [outsideClick]="true"
        >
        <span>
          {{convert('sellModule.manageInventory.advancedSearch.advancedSearchHeader.textMake')}}
          @if (
            (makeOptionsState$ | async)?.selectedMakeOptions.length !==
            (makeOptionsState$ | async)?.filteredMakeOptions.length
            ) {
            <span
              class="indicator"
              >
              ({{ (makeOptionsState$ | async)?.selectedMakeOptions.length }})</span
              >
            }
            @if (
              (makeOptionsState$ | async)?.selectedMakeOptions.length ===
              (makeOptionsState$ | async)?.filteredMakeOptions.length
              ) {
              <span
                >(All)</span
                >
              }
            </span>
            <i class="ms-2 allycon-glyph-chevron-down text-primary" aria-hidden="true"></i>
          </button>

          <ng-template id="makeTemplate" #makeTemplate>
            <div>
              <app-advanced-search-make
                (closePop)="makePop.hide()"
                [localSelecedMake]="localSelecedMake"
              ></app-advanced-search-make>
            </div>
          </ng-template>
        </trap-focus>

        <trap-focus [enableFocusTrap]="modelPop.isOpen" [focusOnFirstElem]="true" [enableArrowKeys]="true">
          <button
            class="btn btn-outline-primary advanced_search--btn"
            type="button"
            [popover]="modelTemplate"
            #modelPop="bs-popover"
            placement="bottom"
            (keydown.escape)="modelPop.hide()"
            [outsideClick]="true"
            >
            <span>
              {{convert('sellModule.manageInventory.advancedSearch.advancedSearchHeader.textModel')}}
              @if (
                (modelOptionsState$ | async)?.selectedModelOptions.length !==
                (modelOptionsState$ | async)?.filteredModelOptions.length
                ) {
                <span
                  class="indicator"
                  >({{ (modelOptionsState$ | async)?.selectedModelOptions.length }})</span
                  >
                }
                @if (
                  (modelOptionsState$ | async)?.selectedModelOptions.length ===
                  (modelOptionsState$ | async)?.filteredModelOptions.length
                  ) {
                  <span
                    >(All)</span
                    >
                  }
                </span>
                <i class="ms-2 allycon-glyph-chevron-down text-primary" aria-hidden="true"></i>
              </button>

              <ng-template id="modelTemplate" #modelTemplate>
                <app-advanced-search-model
                  (closePop)="modelPop.hide()">
                </app-advanced-search-model>
              </ng-template>
            </trap-focus>

            <trap-focus class="hide-popover" [enableFocusTrap]="trimPop.isOpen" [focusOnFirstElem]="true" [enableArrowKeys]="true">
              <button
                class="btn btn-outline-primary advanced_search--btn"
                type="button"
                [popover]="trimTemplate"
                #trimPop=""
                placement="bottom"
                (onShown)="trimVisible = true"
                (onHidden)="trimVisible = false"
                (keydown.escape)="trimPop.hide()"
                [outsideClick]="true"
                >
                <span>
                  {{convert('sellModule.manageInventory.advancedSearch.advancedSearchHeader.textTrim')}}
                  @if (
                    (trimOptionsState$ | async)?.selectedTrimOptions.length !== availableTrimCount) {
                    <span
                      class="indicator"
                      >({{ (trimOptionsState$ | async)?.selectedTrimOptions.length }})</span
                      >
                    }
                    @if (
                      (trimOptionsState$ | async)?.selectedTrimOptions.length ===
                      availableTrimCount) {
                      <span
                        >(All)</span
                        >
                      }
                    </span>
                    <i class="ms-2 allycon-glyph-chevron-down text-primary" aria-hidden="true"></i>
                  </button>

                  <div [class.d-none]="!trimVisible">
                    <app-advanced-search-trim
                      [showDropdown] = "
                      ((modelOptionsState$ | async)?.selectedModelOptions.length === 0) &&
                      ((makeOptionsState$ | async)?.selectedMakeOptions.length === 0)"
                      [trimVisible]="trimVisible"
                      (closePop)="trimVisible = false">
                    </app-advanced-search-trim>
                  </div>

                  <ng-template id="trimTemplate" #trimTemplate>
                  </ng-template>
                </trap-focus>

                @if (advancedSearchService.odometerState$ | async; as vm) {
                  <trap-focus [enableFocusTrap]="odometerPop.isOpen" [focusOnFirstElem]="true" [enableArrowKeys]="true">
                    <button
                      class="btn btn-outline-primary advanced_search--btn"
                      type="button"
                      [popover]="distanceTemplate"
                      #odometerPop="bs-popover"
                      placement="bottom"
                      (keydown.escape)="odometerPop.hide()"
                      [outsideClick]="true"
                      >
                      {{ vm.label }}
                      <i class="ms-2 allycon-glyph-chevron-down text-primary" aria-hidden="true"></i>
                    </button>
                    <ng-template id="distanceTemplate" #distanceTemplate>
                      <app-advanced-search-odometer
                        (closePop)="odometerPop.hide()">
                      </app-advanced-search-odometer>
                    </ng-template>
                  </trap-focus>
                }

                <button
                  class="btn btn-primary text-center advanced_search--btn__search"
                  type="button"
                  data-track-elem="button"
                  data-track-name="Search"
                  (click)="search()"
                  allytmln='advancedSearchButton'
                  >
                  {{convert('sellModule.manageInventory.advancedSearch.advancedSearchHeader.textSearch')}}
                </button>
              </div>
            </ng-container>
